import { Component, Input } from '@angular/core';
import { LoCard, LoSkeleton } from 'lo-design-system';

/**
 * Loading placeholder mirroring {@link EnterpriseCardComponent}: title,
 * "Let's talk" price block, checkmark feature lines and the CTA. `wide` mirrors
 * the full-width arrangement.
 */
@Component({
	standalone: true,
	selector: 'app-enterprise-card-skeleton',
	template: `
		<lo-card>
			@if (wide) {
			<div class="sk-wide">
				<div class="sk-wide__info">
					<lo-skeleton variant="text" width="30%"></lo-skeleton>
					<lo-skeleton variant="text"></lo-skeleton>
					<lo-skeleton variant="text" width="80%"></lo-skeleton>
				</div>
				<lo-skeleton
					variant="block"
					height="calc(var(--lo-space-card) * 3)"
				></lo-skeleton>
			</div>
			} @else {
			<lo-skeleton variant="text" width="50%"></lo-skeleton>
			<lo-skeleton
				variant="block"
				height="calc(var(--lo-space-card) * 1.5)"
			></lo-skeleton>
			<lo-skeleton
				variant="text"
				width="40%"
				height="calc(var(--lo-space-card) * 1.5)"
			></lo-skeleton>
			<lo-skeleton
				variant="block"
				height="calc(var(--lo-space-card) * 1.5)"
			></lo-skeleton>
			<lo-skeleton
				variant="block"
				height="calc(var(--lo-space-card) * 1.5)"
			></lo-skeleton>
			<div class="sk-features">
				@for (row of rows; track row) {
				<lo-skeleton variant="text"></lo-skeleton>
				}
			</div>
			}
		</lo-card>
	`,
	styles: [
		`
			:host {
				display: flex;
				flex-direction: column;

				lo-card {
					flex: 1 1 auto;
				}

				.sk-features,
				.sk-wide__info {
					display: flex;
					flex-direction: column;
					gap: var(--lo-space-gap-md);
				}

				.sk-wide {
					display: grid;
					grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
					gap: var(--lo-space-gap-xl);
				}
			}
		`
	],
	imports: [LoCard, LoSkeleton]
})
export class EnterpriseCardSkeletonComponent {
	@Input() wide = false;
	readonly rows = [0, 1, 2, 3, 4, 5];
}
